var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0; 

(function(){ 

	$(document).ready(function () {
		$('.calendar-block').datepicker({
			changeMonth: false,
			dateFormat: 'mm-dd-yy',
			numberOfMonths: 2,
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = "mm-dd-yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					opencheck = 0;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
				
					
				}
				//console.log(start);
				//console.log(end);

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);
			
			},
			onChangeMonthYear: function () {
				opencheck = 1;
			}
		}); 

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		let op = 0;
		function calendarRange(date){
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn--alt').val());
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut--alt').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-edge';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}
		function calendarSelect (date) {
			let start = ($('#CheckIn--alt').val() !== '') ? $('#CheckIn--alt').val() : $.datepicker.formatDate(DATE_FORMAT, new Date()),
				end = ($('#CheckOut--alt').val() !== '') ? $('#CheckOut--alt').val() : $.datepicker.formatDate(DATE_FORMAT, new Date());
			let startDate = $.datepicker.parseDate(DATE_FORMAT, start);
			let selectedDate = $.datepicker.parseDate(DATE_FORMAT, date);

			if ( op === 0 ) {
				op = 1;
				start = date;
				end =  date;
				$(this).val(start + ' - ');
				$(this).data().datepicker.inline = true;
			} else {
				op = 0;
				if(selectedDate <= startDate){
					end = start;
					start = date;
				} else {
					end =  date;
				}
				$(this).val(start + ' - ' + end);
				$(this).data().datepicker.inline = false;
			}
			$('#CheckIn--alt').val( start );
			$('#CheckOut--alt').val( end );
		}
		function calendarClose () {
			$(this).data().datepicker.inline = false;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = 'mm/dd/y';
		$("#CheckInOut-home").datepicker({
			changeMonth: false,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: calendarRange,
			onSelect: calendarSelect,
			onClose: calendarClose
		});
		$("#CheckInOut-home").on('keyup', function(){
			const dates = $(this).val().split(' - ');
			$('#CheckIn--alt').val( dates[0] );
			$('#CheckOut--alt').val( dates[1] );
		});

		$('.js-open-widget, .booking__close').click(function(e) {
			e.preventDefault();
			$('.booking').toggleClass('open');
		}); 

	});

}());
